import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { pageView } from "@/lib/gtag";

export function usePageTracking() {
  const location = useLocation();

  useEffect(() => {
    const url = window.location.href;
    const title = document.title;
    pageView(url, title);
  }, [location]);
}